import React from "react";
import { Col, Row } from "react-bootstrap";
import vscode from "../../Assets/TechIcons/vscode.svg";
import Figma from "../../Assets/TechIcons/Figma.svg";
import GIMP from "../../Assets/TechIcons/GIMP.svg";
import Ubuntu from "../../Assets/TechIcons/Ubuntu.svg";
import Linux from "../../Assets/TechIcons/Linux.svg";
import Slack from "../../Assets/TechIcons/Slack.svg";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={vscode} alt="Figma" className="tech-icon-images" />
        <div className="tech-icons-text">VSCode</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Figma} alt="Figma" className="tech-icon-images" />
        <div className="tech-icons-text">Figma</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={GIMP} alt="GIMP" className="tech-icon-images" />
        <div className="tech-icons-text">GIMP</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Ubuntu} alt="Ubuntu" className="tech-icon-images" />
        <div className="tech-icons-text">Ubuntu</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Linux} alt="Linux" className="tech-icon-images" />
        <div className="tech-icons-text">Linux</div>
      </Col>

      <Col xs={4} md={2} className="tech-icons ">
        <img src={Slack} alt="Slack" className="tech-icon-images" />
        <div className="tech-icons-text">Slack</div>
      </Col>

    </Row>
  );
}

export default Toolstack;
